import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/signin-logo-upscale-logo.png";
import { FaArrowLeft } from "react-icons/fa";

export const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <div className="coming-soon-container">
      {/* Back Button */}
      <button
        className="back-button"
        onClick={() => navigate("/dashboard")}
        aria-label="Go back to Dashboard"
      >
        <FaArrowLeft />
      </button>

      {/* Bubble Background */}
      <div className="bubbles-coming-soon">
        {[...Array(50)].map((_, i) => (
          <span
            key={i}
            className={i % 2 === 0 ? "bubble-up" : "bubble-down"}
          ></span>
        ))}
      </div>

      {/* Main Content */}
      <div className="content-coming-soon text-center">
        <img src={logo} alt="Go Mak Logo" className="logo-coming-soon" />
        <h1 className="coming-title">Coming Soon</h1>
        <p className="coming-text">
          We’re working hard to bring you something amazing!
        </p>
        <div className="mt-4">
          <button
            className="btn btn-primary px-4 py-2 rounded-pill"
            onClick={() => navigate("/dashboard")}
          >
            Notify Me
          </button>
        </div>
      </div>
    </div>
  );
};
